module.exports = __webpack_public_path__ + "static/media/armySchoolLogo.4a4092eb.png";